export interface IEducation {
  value: TEducationLevel;
  label: string;
}

export type TEducationLevel =
  | 'pre-school-education'
  | 'mandatory-school-education'
  | 'college-education';

export const educationMapping: Record<TEducationLevel, string> = {
  'pre-school-education': 'general.education.nursery',
  'mandatory-school-education': 'general.education.primary',
  'college-education': 'general.education.university',
};

export const educationsLevels = [
  {
    value: 'pre-school-education',
    label: 'general.education.nursery',
  },
  {
    value: 'mandatory-school-education',
    label: 'general.education.primary',
  },
  {
    value: 'college-education',
    label: 'general.education.university',
  },
];
